module.exports = __webpack_public_path__ + "img/petrov.648710e3.png";